import Chip from '@mui/material/Chip';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';

import { TabsContainer as BaseTabsContainer } from 'components/Tabs/styles';

export const TabsContainer = styled(BaseTabsContainer)`
  padding: 15px 20px 20px;
  align-items: stretch;
`;

export const TabHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const TabHeaderTitle = styled.h2`
  margin: 0;
  font-size: 1.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const TabHeaderActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const DataGridWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  border-radius: 4px;
  overflow: hidden;

  & .MuiDataGrid-columnHeaders,
  & .MuiDataGrid-columnHeader,
  & .MuiDataGrid-filler,
  & .MuiDataGrid-scrollbarFiller {
    background-color: ${({ theme }) => theme.palette.grey[50]};
  }
`;

export const ComplianceChip = styled(Chip)<{ $background: string; $color: string }>`
  background-color: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: 1.2rem;
  font-weight: 500;
  height: 24px;
`;

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 1.4rem;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  padding: 16px 24px 8px;
`;

export const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px !important;
`;

export const DialogActions = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 24px;
  justify-content: flex-end;
`;

export const EmDash = styled.span`
  padding: 16px;
`;

export const FileUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
